// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"506112d1","110":"60685845","130":"d27b2712","131":"cefd491e","164":"6241796e","284":"81b51987","461":"00b595c9","488":"0729899e","524":"a4b469f7","525":"f0205572","566":"8f62f6e7","586":"f7cf1732","884":"f4b3ec3d","896":"161f8754"}[chunkId] + ".chunk.js";
};